import Axios from 'axios';

import {
	INDICATORS_PROGRESS_LOADING_TRUE,
	INDICATORS_PROGRESS_GET,
	INDICATORS_PROGRESS_ERROR,
	INDICATORS_RESULTS_LOADING_TRUE,
	INDICATORS_RESULTS_GET,
	INDICATORS_RESULTS_ERROR,
	PAYLOAD_INSIGHTS_LOADING_TRUE,
	PAYLOAD_INSIGHTS_GET,
	PAYLOAD_INSIGHTS_ERROR
} from './types';

import create_query_params from '../utils/create_query_params';

export const indicators_progress_loading_true = () => dispatch => {
  dispatch({
    type: INDICATORS_PROGRESS_LOADING_TRUE
  })
}

export const get_indicators_progress = (filters) => dispatch => {
	dispatch(indicators_progress_loading_true());

	let url = process.env.REACT_APP_SERVER_URL + '/api/indicators/overview?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: INDICATORS_PROGRESS_GET,
			payload: res.data
		})
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: INDICATORS_PROGRESS_ERROR,
			payload: { type: 'indicators_progress', msg: err.message }
		})
	})
}

export const indicators_results_loading_true = () => dispatch => {
	dispatch({
		type: INDICATORS_RESULTS_LOADING_TRUE
	})
}

export const get_indicators_results = (reference) => dispatch => {
	dispatch(indicators_results_loading_true());

	let url = process.env.REACT_APP_SERVER_URL + '/api/indicators/results/overview?';
	let query = create_query_params({ reference, source: 'surveys.responses' });
	url += query;

	Axios.get(url)
	.then((res) => {
		dispatch({
			type: INDICATORS_RESULTS_GET,
			payload: res.data
		})
	}).catch((err) => {
		dispatch({
			type: INDICATORS_RESULTS_ERROR,
			payload: { type: 'indicators_results', msg: err.message }
		})
	})
}

export const payload_insights_loading_true = () => dispatch => {
	dispatch({
		type: PAYLOAD_INSIGHTS_LOADING_TRUE
	})
}

export const get_payload_insights = (payload_id) => dispatch => {
	dispatch(payload_insights_loading_true());

	let url = process.env.REACT_APP_SERVER_URL + '/api/indicators/insights/latest?';
	let query = create_query_params({ payload: payload_id });
	url += query;

	Axios.get(url)
	.then((res) => {
		dispatch({
			type: PAYLOAD_INSIGHTS_GET,
			payload: res.data
		})
	}).catch((err) => {
		dispatch({
			type: PAYLOAD_INSIGHTS_ERROR,
			payload: { type: 'payload_insights', msg: err.message }
		})
	})
}
